import React from "react";
import Dashboard from "../Dashboard";
import Bien from "../Bien";
import Notaire from "../Notaire";
import Documents from "../Documents";
import Interlocuteurs from "../Interlocuteurs";
import Profil from "../Profil";
import Message from "../Message";

import DashboardDonation from "../donation/DashboardDonation";
import DocumentsDonation from "../donation/DocumentsDonation";

import DashboardPma from "../pma/Dashboard";
import DocumentsPma from "../pma/Documents";
import NotairePma from "../pma/Notaire";

import DashboardMariage from "../mariage/Dashboard";
import DocumentsMariage from "../mariage/Documents";
import NotaireMariage from "../mariage/Notaire";

import DashboardPacs from "../pacs/Dashboard";
import DocumentsPacs from "../pacs/Documents";
import NotairePacs from "../pacs/Notaire";

import DashboardEmpty from "../empty/Dashboard";
import NotaireEmpty from "../empty/Notaire";

import { TabPane } from "reactstrap";

export function getTabPanesByDemarche(demarche, data) {
  switch (demarche) {
    case "transaction":
    case "transaction_vendeur":
      return (
        <>
          <TabPane tabId="dashboard"><Dashboard {...data} /></TabPane>
          <TabPane tabId="bien"><Bien user={data.user} bien={data.bien} /></TabPane>
          <TabPane tabId="notaire"><Notaire user={data.user} transaction={data.transaction} evenement={data.evenement} /></TabPane>
          <TabPane tabId="documents"><Documents user={data.user} transaction={data.transaction} document={data.document} /></TabPane>
          <TabPane tabId="interlocuteurs"><Interlocuteurs user={data.user} transaction={data.transaction} /></TabPane>
          <TabPane tabId="profil"><Profil user={data.user} transaction={data.transaction} /></TabPane>
          <TabPane tabId="message"><Message user={data.user} affaire={data.transaction} /></TabPane>
        </>
      );

    case "donation":
      return (
        <>
          <TabPane tabId="dashboard-donation"><DashboardDonation {...data} /></TabPane>
          <TabPane tabId="document-donation"><DocumentsDonation user={data.user} /></TabPane>
          <TabPane tabId="profil"><Profil user={data.user} /></TabPane>
        </>
      );

    case "pma":
      return (
        <>
          <TabPane tabId="dashboard-pma"><DashboardPma {...data} /></TabPane>
          <TabPane tabId="notaire-pma"><NotairePma user={data.user} pma={data.pma} evenement={data.evenement} /></TabPane>
          <TabPane tabId="document-pma"><DocumentsPma {...data} /></TabPane>
          <TabPane tabId="message"><Message user={data.user} affaire={data.pma} /></TabPane>
          <TabPane tabId="profil"><Profil user={data.user} /></TabPane>
        </>
      );

    case "mariage":
      return (
        <>
          <TabPane tabId="dashboard-mariage"><DashboardMariage {...data} /></TabPane>
          <TabPane tabId="notaire-mariage"><NotaireMariage {...data} /></TabPane>
          <TabPane tabId="document-mariage"><DocumentsMariage {...data} /></TabPane>
          <TabPane tabId="message"><Message user={data.user} affaire={data.mariage} /></TabPane>
          <TabPane tabId="profil"><Profil user={data.user} /></TabPane>
        </>
      );
      case "pacs":
      return (
        <>
          <TabPane tabId="dashboard-pacs"><DashboardPacs {...data} /></TabPane>
          <TabPane tabId="notaire-pacs"><NotairePacs {...data} /></TabPane>
          <TabPane tabId="document-pacs"><DocumentsPacs {...data} /></TabPane>
          <TabPane tabId="message"><Message user={data.user} affaire={data.pacs} /></TabPane>
          <TabPane tabId="profil"><Profil user={data.user} /></TabPane>
        </>
      );

      case "aucune_demarche":
      return (
        <>
          <TabPane tabId="dashboard-empty"><DashboardEmpty {...data} /></TabPane>
          <TabPane tabId="notaire-empty"><NotaireEmpty {...data} /></TabPane>
          <TabPane tabId="message"><Message user={data.user} affaire={data.aucune_demarche} /></TabPane>
          <TabPane tabId="profil"><Profil user={data.user} /></TabPane>
        </>
      );

    default:
      return null;
  }
}